import React from "react";
import { useConsultModal } from "@/components/ConsultModal";
import { ArrowRight, PhoneCall, Headset } from "@phosphor-icons/react";

/** Reusable "didn't find what you were looking for" CTA band, placed below the
 * therapist/mentor directories so the page never ends in an awkward empty area. */
export default function DirectoryHelpBand({ kind = "therapist" }) {
  const { open: openConsult } = useConsultModal();
  const isTherapist = kind === "therapist";
  return (
    <section className="md-section md-directory-help-band" data-testid={`directory-help-band-${kind}`}>
      <div className="md-container">
        <div className="md-directory-help-card">
          <div className="md-directory-help-ico" aria-hidden>
            <Headset size={28} weight="duotone" />
          </div>
          <div className="md-directory-help-body">
            <div className="md-label-eyebrow md-directory-help-eyebrow">Not sure who fits?</div>
            <h3 className="md-directory-help-title font-serif">
              {isTherapist
                ? "Let us help you choose the right therapist."
                : "Let us help you choose the right mentor."}
            </h3>
            <p className="md-directory-help-sub">
              Book a free 20-minute call with Shreeja. We&apos;ll listen, then point you to the
              {isTherapist ? " clinician" : " mentor"} who fits, no pressure, no commitment.
            </p>
          </div>
          <div className="md-directory-help-actions">
            <button onClick={openConsult} className="btn-primary" data-testid={`directory-help-consult-${kind}`}>
              <PhoneCall size={14} weight="bold" /> Free Consultation
            </button>
            <a
              href={isTherapist ? "https://wa.link/os5se2" : "https://wa.link/v2m2h5"}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline md-career-outline-light"
              data-testid={`directory-help-contact-${kind}`}
            >
              Talk to us <ArrowRight size={14} weight="bold" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
